import { asyncSimpleModal } from '../../../../../lib/common';
import useToastMsg from '../../../../../hooks/common/useToastMsg';
import {
  CATEGORY_EXHIBIT_TYPE,
  CATEGORY_TYPE,
  EMPHASIS_CATEGORY_EXHIBIT_MAX_LENGTH,
  GENERAL_CATEGORY_EXHIBIT_MAX_LENGTH,
} from '../../../../../constants/service/app/categoryConstants';
import categoryToastMsg from '../../../../../constants/service/toastMsg/categoryToastMsg';

export const useCategoryController = (props) => {
  const {
    exhibitGeneralCategoryDataSource,
    exhibitEmphasisCategoryDataSource,
    exhibitCategoryTabType,
    totalCategoryTabType,
    setTotalCategoryDataSource,
    selectedTotalMainCategoryList,
    selectedTotalSubCategoryList,
    selectedExhibitMainCategoryList,
    selectedExhibitSubCategoryList,
    setSelectedExhibitMainCategoryList,
    setSelectedExhibitSubCategoryList,
    setSelectedTotalMainCategoryList,
    setSelectedTotalSubCategoryList,
    setExhibitGeneralCategoryDataSource,
    setExhibitEmphasisCategoryDataSource,
  } = props;
  const { error } = useToastMsg();

  // 카테고리 제외 버튼을 눌렀을 때
  const onInexhibit = async () => {
    const result = await asyncSimpleModal({
      type: 'confirm',
      title: '카테고리 제외',
      message: 'App/Web에서 해당 카테고리의 정보가 노출 되지 않습니다.\n\n 비노출 하시겠습니까?',
    });

    if (!result) return;

    // 제외할 카테고리와 현재 선택 된 카테고리 전체 리스트의 카테고리 속성 정보가 다를 때
    if (exhibitCategoryTabType !== totalCategoryTabType) {
      const result = await asyncSimpleModal({
        type: 'info',
        title: '카테고리 제외',
        message: '카테고리 속성 정보가 상이합니다. 카테고리 속성 정보가 동일한 카테고리를 선택해주세요',
      });

      if (result) return;
    }

    // 전시 제외할 전체 카테고리(일반형, 강조형 포함) 업데이트
    setTotalCategoryDataSource((prev) =>
      prev.map((mainCategory) => {
        // 1차 카테고리를 제외했을 경우 2차 카테고리까지 모두 비노출 처리
        if (selectedExhibitMainCategoryList.map((category) => category.id).includes(mainCategory.id)) {
          return {
            ...mainCategory,
            isExhibit: CATEGORY_EXHIBIT_TYPE.INEXHIBIT,
            children: mainCategory.children.map((subCategory) => {
              if (selectedExhibitSubCategoryList.map((category) => category.id).includes(subCategory.id))
                return {
                  ...subCategory,
                  isExhibit: CATEGORY_EXHIBIT_TYPE.INEXHIBIT,
                };
              return subCategory;
            }),
          };
        }
        // 2차 카테고리만 제외했을 경우
        return {
          ...mainCategory,
          children: mainCategory.children.map((subCategory) => {
            if (selectedExhibitSubCategoryList.map((category) => category.id).includes(subCategory.id))
              return {
                ...subCategory,
                isExhibit: CATEGORY_EXHIBIT_TYPE.INEXHIBIT,
              };
            return subCategory;
          }),
        };
      }),
    );

    // 전시 제외 할 카테고리 중 일반형 카테고리를 선택한 경우가 있을 경우
    if (
      selectedExhibitMainCategoryList.map((category) => category.type).includes(CATEGORY_TYPE.GENERAL) ||
      selectedExhibitSubCategoryList.map((category) => category.parentType).includes(CATEGORY_TYPE.GENERAL)
    ) {
      // 전시 일반 카테고리 리스트에서 전시 제외 적용 및 순서 재적용
      setExhibitGeneralCategoryDataSource((prev) =>
        prev
          .filter(
            (mainCategory) => !selectedExhibitMainCategoryList.map((category) => category.id).includes(mainCategory.id),
          )
          .map((mainCategory, mainIndex) => ({
            ...mainCategory,
            order: mainIndex + 1,
            children: mainCategory.children
              .filter(
                (subCategory) =>
                  !selectedExhibitSubCategoryList.map((category) => category.id).includes(subCategory.id),
              )
              .map((subCategory, subIndex) => ({
                ...subCategory,
                order: `${mainIndex + 1}-${subIndex + 1}`,
              })),
          })),
      );

      // 전체 일반 카테고리 리스트에서 전시 제외 적용
      setTotalCategoryDataSource((prev) =>
        prev.map((mainCategory) => {
          // 1차 카테고리를 제외했을 경우 2차 카테고리까지 모두 비노출 처리
          if (selectedExhibitMainCategoryList.map((category) => category.id).includes(mainCategory.id)) {
            return {
              ...mainCategory,
              isExhibit: CATEGORY_EXHIBIT_TYPE.INEXHIBIT,
              children: mainCategory.children.map((subCategory) => {
                if (selectedExhibitSubCategoryList.map((category) => category.id).includes(subCategory.id))
                  return {
                    ...subCategory,
                    isExhibit: CATEGORY_EXHIBIT_TYPE.INEXHIBIT,
                  };
                return subCategory;
              }),
            };
          }
          // 2차 카테고리만 제외했을 경우
          return {
            ...mainCategory,
            children: mainCategory.children.map((subCategory) => {
              if (selectedExhibitSubCategoryList.map((category) => category.id).includes(subCategory.id))
                return {
                  ...subCategory,
                  isExhibit: CATEGORY_EXHIBIT_TYPE.INEXHIBIT,
                };
              return subCategory;
            }),
          };
        }),
      );
    }

    // 전시 제외 할 카테고리 중 강조형 카테고리를 선택한 경우가 있을 경우
    if (
      selectedExhibitMainCategoryList.map((category) => category.type).includes(CATEGORY_TYPE.EMPHASIS) ||
      selectedExhibitSubCategoryList.map((category) => category.parentType).includes(CATEGORY_TYPE.EMPHASIS)
    ) {
      // 전시 강조 카테고리 리스트에서 선택한 카테고리 전시 제외 적용 및 순서 재적용
      setExhibitEmphasisCategoryDataSource((prev) =>
        prev
          .filter(
            (mainCategory) => !selectedExhibitMainCategoryList.map((category) => category.id).includes(mainCategory.id),
          )
          .map((mainCategory, mainIndex) => ({
            ...mainCategory,
            order: mainIndex + 1,
            children: mainCategory.children
              .filter(
                (subCategory) =>
                  !selectedExhibitSubCategoryList.map((category) => category.id).includes(subCategory.id),
              )
              .map((subCategory, subIndex) => ({
                ...subCategory,
                order: `${mainIndex + 1}-${subIndex + 1}`,
              })),
          })),
      );

      // 전체 강조 카테고리 리스트에서 선택한 카테고리 전시 제외 적용
      setTotalCategoryDataSource((prev) =>
        prev.map((mainCategory) => {
          // 1차 카테고리를 제외했을 경우 2차 카테고리까지 모두 비노출 처리
          if (selectedExhibitMainCategoryList.map((category) => category.id).includes(mainCategory.id)) {
            return {
              ...mainCategory,
              isExhibit: CATEGORY_EXHIBIT_TYPE.INEXHIBIT,
              children: mainCategory.children.map((subCategory) => {
                if (selectedExhibitSubCategoryList.map((category) => category.id).includes(subCategory.id))
                  return {
                    ...subCategory,
                    isExhibit: CATEGORY_EXHIBIT_TYPE.INEXHIBIT,
                  };
                return subCategory;
              }),
            };
          }
          // 2차 카테고리만 제외했을 경우
          return {
            ...mainCategory,
            children: mainCategory.children.map((subCategory) => {
              if (selectedExhibitSubCategoryList.map((category) => category.id).includes(subCategory.id))
                return {
                  ...subCategory,
                  isExhibit: CATEGORY_EXHIBIT_TYPE.INEXHIBIT,
                };
              return subCategory;
            }),
          };
        }),
      );
    }

    // 카테고리 제외 후 선택한 1차, 2차 전시 카테고리 리스트 초기화
    setSelectedExhibitMainCategoryList([]);
    setSelectedExhibitSubCategoryList([]);
  };

  // 전시 추가 버튼을 눌렀을 때
  const onExhibit = async () => {
    // 선택한 1차 또는 2차 카테고리가 모두 전시 상태일 경우 전시 중인 카테고리라고 모달 노출
    if (
      !selectedTotalMainCategoryList.find(
        (mainCategory) => mainCategory.isExhibit === CATEGORY_EXHIBIT_TYPE.INEXHIBIT,
      ) &&
      !selectedTotalSubCategoryList.find((subCategory) => subCategory.isExhibit === CATEGORY_EXHIBIT_TYPE.INEXHIBIT)
    ) {
      const result = await asyncSimpleModal({
        type: 'warning',
        title: '카테고리 전시 설정',
        message: '선택하신 카테고리는 현재 전시 중인 카테고리입니다.\n 카테고리 정보를 다시 확인해 주세요',
      });

      // 모달을 닫고 편집 중인 상태로 돌아감
      if (result) return;
    }

    // 추가할 카테고리와 현재 선택 된 카테고리 전체 리스트의 카테고리 속성 정보가 다를 때
    if (exhibitCategoryTabType !== totalCategoryTabType) {
      const result = await asyncSimpleModal({
        type: 'info',
        title: '카테고리 추가',
        message: '카테고리 속성 정보가 상이합니다. 카테고리 속성 정보가 동일한 카테고리를 선택해주세요',
      });

      if (result) return;
    }

    // 선택된 카테고리 중에 이미 전시된 카테고리에 대한 중복 데이터를 제거한 후
    // 전시된 카테고리 + 새로 선택된 카테고리 갯수의 합이 총 전시 가능 갯수를 넘으면 오류 발생
    const exhibitGeneralCategoryIds = exhibitGeneralCategoryDataSource.map(({ id }) => id);
    const nonExhibitGeneralCategoryDataSource = selectedTotalMainCategoryList
      .filter((item) => item.type === CATEGORY_TYPE.GENERAL)
      .filter(({ id }) => !exhibitGeneralCategoryIds.includes(id));
    const exhibitEmphasisCategoryIds = exhibitEmphasisCategoryDataSource.map(({ id }) => id);
    const nonExhibitEmphasisCategoryDataSource = selectedTotalMainCategoryList
      .filter((item) => item.type === CATEGORY_TYPE.EMPHASIS)
      .filter(({ id }) => !exhibitEmphasisCategoryIds.includes(id));
    if (
      exhibitGeneralCategoryDataSource.length + nonExhibitGeneralCategoryDataSource.length >
        GENERAL_CATEGORY_EXHIBIT_MAX_LENGTH ||
      exhibitEmphasisCategoryDataSource.length + nonExhibitEmphasisCategoryDataSource.length >
        EMPHASIS_CATEGORY_EXHIBIT_MAX_LENGTH
    ) {
      return error(
        categoryToastMsg.CATEGORY_EXHIBIT_MAX_SIZE_ERROR,
        new Error(categoryToastMsg.CATEGORY_EXHIBIT_MAX_SIZE_ERROR),
      );
    }

    // 전시 추가할 전체 카테고리(일반형, 강조형 포함) 업데이트
    setTotalCategoryDataSource((prev) =>
      prev
        .map((mainCategory) => {
          // 추가할 1차 카테고리가 미전시 상태일 때 전시 상태로 바꿔서 반환
          if (
            selectedTotalMainCategoryList.map((mainCategory) => mainCategory.id).includes(mainCategory.id) &&
            mainCategory.isExhibit === CATEGORY_EXHIBIT_TYPE.INEXHIBIT
          )
            return {
              ...mainCategory,
              isExhibit: CATEGORY_EXHIBIT_TYPE.EXHIBIT,
            };

          // 추가할 1차 카테고리가 전시 상태일 때 그대로 반환
          return mainCategory;
        })
        .map((mainCategory) => ({
          ...mainCategory,
          children: mainCategory.children.map((subCategory) => {
            // 추가할 2차 카테고리가 미전시 상태일 때 전시 상태로 바꿔서 반환
            if (
              selectedTotalSubCategoryList.map((subCategory) => subCategory.id).includes(subCategory.id) &&
              subCategory.isExhibit === CATEGORY_EXHIBIT_TYPE.INEXHIBIT
            )
              return {
                ...subCategory,
                isExhibit: CATEGORY_EXHIBIT_TYPE.EXHIBIT,
              };
            // 추가할 2차 카테고리가 전시 상태일 때 그대로 반환
            return subCategory;
          }),
        })),
    );

    // 전시 추가 할 카테고리 중 일반 카테고리를 선택한 경우가 있을 경우
    if (selectedTotalMainCategoryList.map((category) => category.type).includes(CATEGORY_TYPE.GENERAL)) {
      // 전시 일반 카테고리 리스트에서 전시 추가 적용 및 순서 재적용
      setExhibitGeneralCategoryDataSource((prev) =>
        prev
          .map((mainCategory) => {
            // 선택한 2차 카테고리의 1차 카테고리가 아닐 경우 1차 카테고리 정보 그대로 반환
            if (!selectedTotalSubCategoryList.map((subCategory) => subCategory.parentId).includes(mainCategory.id))
              return mainCategory;

            // 1차 카테고리가 전시중면서 해당 2차 카테고리의 1차 카테고리일 때 미전시 상태인 2차 카테고리를 전시 중인 2차 카테고리 배열에 추가
            return {
              ...mainCategory,
              children: [
                ...mainCategory.children,
                ...selectedTotalSubCategoryList
                  .filter(
                    (subCategory) =>
                      subCategory.parentId === mainCategory.id &&
                      subCategory.isExhibit === CATEGORY_EXHIBIT_TYPE.INEXHIBIT,
                  )
                  .map((selectedSubCategory, selectedSubIndex) => ({
                    ...selectedSubCategory,
                    order: `${mainCategory.order}-${mainCategory.children.length + selectedSubIndex + 1}`,
                  })),
              ],
            };
          })
          // 1차 카테고리, 2차 카테고리가 모두 미전시 상태이면서 전시 추가 하지 않았고, 1차 카테고리가 일반형일 때, 전시 일반 카테고리 배열 끝에 모두 전시 카테고리로 추가
          .concat(
            selectedTotalMainCategoryList
              .filter(
                (mainCategory) =>
                  !exhibitGeneralCategoryDataSource.map((category) => category.id).includes(mainCategory.id) &&
                  mainCategory.type === CATEGORY_TYPE.GENERAL,
              )
              .map((selectedTotalMainCategory, selectedTotalMainCategoryIndex) => ({
                ...selectedTotalMainCategory,
                order: String(prev.length + selectedTotalMainCategoryIndex + 1),
                children: selectedTotalMainCategory.children
                  .filter((subCategory) => subCategory.isExhibit === CATEGORY_EXHIBIT_TYPE.INEXHIBIT)
                  .filter((subCategory) =>
                    selectedTotalSubCategoryList
                      .map((selectedTotalSubCategory) => selectedTotalSubCategory.id)
                      .includes(subCategory.id),
                  )
                  .map((subCategory, subIndex) => ({
                    ...subCategory,
                    order: `${prev.length + selectedTotalMainCategoryIndex + 1}-${subIndex + 1}`,
                  })),
              })),
          ),
      );

      // 전체 일반 카테고리 리스트에서 선택한 카테고리 전시 상태 추가 적용
      setTotalCategoryDataSource((prev) =>
        prev
          .map((mainCategory) => {
            // 추가할 1차 카테고리가 미전시 상태일 때 전시 상태로 바꿔서 반환
            if (
              selectedTotalMainCategoryList.map((mainCategory) => mainCategory.id).includes(mainCategory.id) &&
              mainCategory.isExhibit === CATEGORY_EXHIBIT_TYPE.INEXHIBIT
            )
              return {
                ...mainCategory,
                isExhibit: CATEGORY_EXHIBIT_TYPE.EXHIBIT,
              };

            // 추가할 1차 카테고리가 전시 상태일 때 그대로 반환
            return mainCategory;
          })
          .map((mainCategory) => ({
            ...mainCategory,
            children: mainCategory.children.map((subCategory) => {
              // 추가할 2차 카테고리가 미전시 상태일 때 전시 상태로 바꿔서 반환
              if (
                selectedTotalSubCategoryList.map((subCategory) => subCategory.id).includes(subCategory.id) &&
                subCategory.isExhibit === CATEGORY_EXHIBIT_TYPE.INEXHIBIT
              )
                return {
                  ...subCategory,
                  isExhibit: CATEGORY_EXHIBIT_TYPE.EXHIBIT,
                };
              // 추가할 2차 카테고리가 전시 상태일 때 그대로 반환
              return subCategory;
            }),
          })),
      );
    }

    // 전시 추가 할 카테고리 중 강조 카테고리를 선택한 경우가 있을 경우
    if (selectedTotalMainCategoryList.map((category) => category.type).includes(CATEGORY_TYPE.EMPHASIS)) {
      // 전시 추가 할 강조형 카테고리를 골랐을 때
      setExhibitEmphasisCategoryDataSource((prev) =>
        prev
          .map((mainCategory) => {
            // 선택한 2차 카테고리의 1차 카테고리가 아닐 경우 1차 카테고리 정보 그대로 반환
            if (!selectedTotalSubCategoryList.map((subCategory) => subCategory.parentId).includes(mainCategory.id))
              return mainCategory;

            // 1차 카테고리가 전시중이고 해당 2차 카테고리의 1차 카테고리이면서, 미전시 상태인 2차 카테고리를 전시 중인 2차 카테고리 배열에 추가
            return {
              ...mainCategory,
              children: [
                ...mainCategory.children,
                ...selectedTotalSubCategoryList
                  .filter(
                    (subCategory) =>
                      subCategory.parentId === mainCategory.id &&
                      subCategory.isExhibit === CATEGORY_EXHIBIT_TYPE.INEXHIBIT,
                  )
                  .map((selectedSubCategory, selectedSubIndex) => ({
                    ...selectedSubCategory,
                    order: `${mainCategory.order}-${mainCategory.children.length + selectedSubIndex + 1}`,
                  })),
              ],
            };
          })
          // 1차 카테고리, 2차 카테고리가 모두 미전시 상태이면서 전시 추가하지 않았고, 1차 카테고리가 강조형일 때, 전시 강조 카테고리 배열 끝에 모두 전시 카테고리로 추가
          .concat(
            selectedTotalMainCategoryList
              .filter(
                (mainCategory) =>
                  !exhibitEmphasisCategoryDataSource.map((category) => category.id).includes(mainCategory.id) &&
                  mainCategory.type === CATEGORY_TYPE.EMPHASIS,
              )
              .map((selectedTotalMainCategory, selectedTotalMainCategoryIndex) => ({
                ...selectedTotalMainCategory,
                order: String(prev.length + selectedTotalMainCategoryIndex + 1),
                children: selectedTotalMainCategory.children
                  .filter((subCategory) => subCategory.isExhibit === CATEGORY_EXHIBIT_TYPE.INEXHIBIT)
                  .filter((subCategory) =>
                    selectedTotalSubCategoryList
                      .map((selectedTotalSubCategory) => selectedTotalSubCategory.id)
                      .includes(subCategory.id),
                  )
                  .map((subCategory, subIndex) => ({
                    ...subCategory,
                    order: `${prev.length + selectedTotalMainCategoryIndex + 1}-${subIndex + 1}`,
                  })),
              })),
          ),
      );

      // 전체 강조 카테고리 리스트에서 선택한 카테고리 전시 상태 추가 적용
      setTotalCategoryDataSource((prev) =>
        prev
          .map((mainCategory) => {
            // 추가할 1차 카테고리가 미전시 상태일 때 전시 상태로 바꿔서 반환
            if (
              selectedTotalMainCategoryList.map((mainCategory) => mainCategory.id).includes(mainCategory.id) &&
              mainCategory.isExhibit === CATEGORY_EXHIBIT_TYPE.INEXHIBIT
            )
              return {
                ...mainCategory,
                isExhibit: CATEGORY_EXHIBIT_TYPE.EXHIBIT,
              };

            // 추가할 1차 카테고리가 전시 상태일 때 그대로 반환
            return mainCategory;
          })
          .map((mainCategory) => ({
            ...mainCategory,
            children: mainCategory.children.map((subCategory) => {
              // 추가할 2차 카테고리가 미전시 상태일 때 전시 상태로 바꿔서 반환
              if (
                selectedTotalSubCategoryList.map((subCategory) => subCategory.id).includes(subCategory.id) &&
                subCategory.isExhibit === CATEGORY_EXHIBIT_TYPE.INEXHIBIT
              )
                return {
                  ...subCategory,
                  isExhibit: CATEGORY_EXHIBIT_TYPE.EXHIBIT,
                };
              // 추가할 2차 카테고리가 전시 상태일 때 그대로 반환
              return subCategory;
            }),
          })),
      );
    }

    // 카테고리 추가 후 선택한 1차, 2차 전체 카테고리 리스트 초기화
    setSelectedTotalMainCategoryList([]);
    setSelectedTotalSubCategoryList([]);
  };

  //전시 카테고리에서 삭제 버튼을 눌렀을 때
  const onDeleteExhibitCategory = async (target) => {
    const result = await asyncSimpleModal({
      type: 'confirm',
      title: '카테고리 제외',
      message: `${target.productCount}개의 상품이 연결된 카테고리입니다. App/Web에서 해당 카테고리의 정보가 노출되지 않습니다.\n\n 비노출 하시겠습니까?`,
    });

    if (!result) return;

    // 제외할 카테고리와 현재 선택 된 카테고리 전체 리스트의 카테고리 속성 정보가 다를 때
    if (exhibitCategoryTabType !== totalCategoryTabType) {
      const result = await asyncSimpleModal({
        type: 'info',
        title: '카테고리 제외',
        message: '카테고리 속성 정보가 상이합니다. 카테고리 속성 정보가 동일한 카테고리를 선택해주세요',
      });

      if (result) return;
    }

    // 전체 카테고리(일반형, 강조형 포함) 리스트에 카테고리 미전시 상태 업데이트
    setTotalCategoryDataSource((prev) => {
      // 2차 카테고리를 비노출 처리 했을 경우
      if (target.parentId) {
        return prev.map((mainCategory) => {
          // 비노출한 2차 카테고리의 1차 카테고리에 해당하지 않는 카테고리들은 그대로 반환
          if (mainCategory.id !== target.parentId) return mainCategory;

          // 2차 카테고리 비노출 처리
          return {
            ...mainCategory,
            children: mainCategory.children.map((subCategory) => {
              // 삭제할 2차 카테고리가 아닐경우 그대로 반환
              if (subCategory.id !== target.id) return subCategory;

              // 삭제한 2차 카테고리는 미전시 상태로 수정
              return {
                ...subCategory,
                isExhibit: CATEGORY_EXHIBIT_TYPE.INEXHIBIT,
              };
            }),
          };
        });
      }

      // 1차 카테고리를 삭제했을 경우 하위 2차 카테고리까지 모두 비노출 처리
      return prev.map((mainCategory) => {
        // 비노출한 1차 카테고리에 해당하지 않는 카테고리들은 그대로 반환
        if (mainCategory.id !== target.id) return mainCategory;

        return {
          ...mainCategory,
          isExhibit: CATEGORY_EXHIBIT_TYPE.INEXHIBIT,
          children: mainCategory.children.map((subCategory) => ({
            ...subCategory,
            isExhibit: CATEGORY_EXHIBIT_TYPE.INEXHIBIT,
          })),
        };
      });
    });

    const deleteCategory = (prev) => {
      // 2차 카테고리를 삭제했을 경우
      if (target.parentId) {
        return prev.map((category, mainIndex) => {
          // 삭제한 2차 카테고리의 1차 카테고리에 해당하지 않는 카테고리들은 그대로 반환
          if (category.id !== target.parentId) return category;

          // 2차 카테고리 삭제 후 순서 재정렬
          return {
            ...prev[Number(target.order.split('-')[0]) - 1],
            children: prev[Number(target.order.split('-')[0]) - 1].children
              .filter((subCategory) => subCategory.id !== target.id)
              .map((subCategory, subIndex) => ({
                ...subCategory,
                order: `${mainIndex + 1}-${subIndex + 1}`,
              })),
          };
        });
      }

      // 1차 카테고리를 삭제했을 경우 삭제 후 순서 재정렬
      return prev
        .filter((mainCategory) => mainCategory.id !== target.id)
        .map((category, index) => ({ ...category, order: String(index + 1) }));
    };

    if (target.parentType === CATEGORY_TYPE.GENERAL || target.type === CATEGORY_TYPE.GENERAL) {
      setExhibitGeneralCategoryDataSource(deleteCategory);
    } else if (target.parentType === CATEGORY_TYPE.EMPHASIS || target.type === CATEGORY_TYPE.EMPHASIS) {
      setExhibitEmphasisCategoryDataSource(deleteCategory);
    }
  };

  return { onInexhibit, onExhibit, onDeleteExhibitCategory };
};
